import React, { useEffect, useState } from "react";

const Navbar = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [holidayMessage, setHolidayMessage] = useState('');
  const [holidayEmoji, setHolidayEmoji] = useState('');
  const [holidayColor, setHolidayColor] = useState('');





  // Validate the token
  const validateToken = async () => {
    const accessToken = localStorage.getItem("accessToken");

    try {
	  if(!accessToken) return;
      const response = await fetch(`https://api.viralgpt.com/auth/validate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: accessToken }),
      });

      if (!response.ok) {
        console.warn("Token is invalid or expired. Redirecting to login...");
        localStorage.removeItem("accessToken");
      } else {
        setLoggedIn(true);
      }
    } catch (err) {
      console.error("Failed to validate token:", err);
      localStorage.removeItem("accessToken");
    }
  };

  // Set holiday theme based on current month
  useEffect(() => {
    const today = new Date();
    const month = today.getMonth() + 1;

    switch(month) {
      case 1:
        setHolidayMessage("NEW YEAR SALE");
        setHolidayEmoji("🎊");
        setHolidayColor("#333333");
        break;
      case 2:
        setHolidayMessage("VALENTINES DAY SALE");
        setHolidayEmoji("💕");
        setHolidayColor("#D81B60");
        break;
      case 3:
        setHolidayMessage("ST PATRICKS DAY SALE");
        setHolidayEmoji("🍀");
        setHolidayColor("#1B5E20");
        break;
      case 4:
        setHolidayMessage("SPRING SALE");
        setHolidayEmoji("🦋");
        setHolidayColor("#2E7D32");
        break;
      case 5:
        setHolidayMessage("MAY MADNESS SALE");
        setHolidayEmoji("🎉");
        setHolidayColor("#4A148C");
        break;
      case 6:
        setHolidayMessage("SUMMER SALE");
        setHolidayEmoji("🌴");
        setHolidayColor("#0277BD");
        break;
      case 7:
        setHolidayMessage("4TH OF JULY DAY SALE");
        setHolidayEmoji("🇺🇸");
        setHolidayColor("#B71C1C");
        break;
      case 8:
        setHolidayMessage("BACK TO SCHOOL SALE");
        setHolidayEmoji("✏️");
        setHolidayColor("#1A237E");
        break;
      case 9:
        setHolidayMessage("FALL SPECIAL SALE");
        setHolidayEmoji("🌻");
        setHolidayColor("#8B4513");
        break;
      case 10:
        setHolidayMessage("HALLOWEEN SALE");
        setHolidayEmoji("👻");
        setHolidayColor("#000000");
        break;
      case 11:
        setHolidayMessage("BLACK FRIDAY SALE");
        setHolidayEmoji("💫");
        setHolidayColor("#212121");
        break;
      case 12:
        setHolidayMessage("HOLIDAY SEASON SALE");
        setHolidayEmoji("❄️");
        setHolidayColor("#1B5E20");
        break;
      default:
        break;
    }
  }, []);

  // Check token validity on component mount
  useEffect(() => {
    validateToken();
  }, []);

  return (
    <>
      <style>
        {`
          .holiday-banner {
            background-color: ${holidayColor}66;
            color: white;
            position: relative;
            overflow: hidden;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            backdrop-filter: blur(5px);
          }
          .holiday-banner::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0.08;
            background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 20px,
              currentColor 20px,
              currentColor 40px
            );
            pointer-events: none;
            z-index: 0;
          }
          .holiday-banner a {
            position: relative;
            z-index: 1;
          }
        `}
      </style>

     

      <nav className="bg-white border-bottom-0 border-gray-200 shadow-sm sticky-top">
		 {/* Holiday Banner */}
		 <div className="holiday-banner text-center py-2">
        <a href="/pricing" className="text-decoration-none">
          <span className="pill px-4 py-2 rounded-pill d-inline-block" 
            style={{
              fontSize: '0.75rem',
              backgroundColor: holidayColor,
              color: 'white',
              transition: 'all 0.3s ease',
              boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
            }}>
            <strong>
              {holidayEmoji} {holidayMessage} {holidayEmoji} 50% OFF ANNUAL PLANS
              <span className="ms-1 px-1 countdown-timer border d-none" 
                style={{
                  fontSize: '0.75rem',
                  backgroundColor: `${holidayColor}66`,
                  color: 'white',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
                }}>
              </span>
            </strong>
          </span>
        </a>
      </div>
        <div className="max-w-screen-xl mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo Section */}
            <div className="flex items-center space-x-3">
              <a href="/" className="text-decoration-none">
                <span className="text-2xl font-semibold text-gray-900 flex items-center">
                  <img src="/images/logo-icon.png" alt="Chart icon" className="h-8 w-8 mr-2" />
                  <span className="text-instagram">ViralGPT</span>
                </span>
              </a>
            </div>

            {/* Navigation Links */}
            <div className="hidden md:flex space-x-8 justify-center flex-1">
           
              <a
                href="/pricing"
                className="flex items-center text-gray-700 hover:text-blue-600 space-x text-decoration-none"
              >
                <span>PRICING</span>
              </a>
              <a
                href="#faq"
                className="flex items-center text-gray-700 hover:text-blue-600 space-x-2 text-decoration-none"
              >
                <span>FAQ</span>
              </a>
            </div>

            {/* Right Side Links */}
            <div className="flex items-center space-x-2">
              <a
                href="/login"
                className="text-gray-700 hover:text-blue-600 font-medium text-decoration-none"
              >
                {!loggedIn ? "Log In" : ""}
              </a>
              <a
                href="/register"
                className="rounded bg-instagram text-decoration-none text-white px-2 py-2 shadow-md"
              >
                {!loggedIn ? "Purchase" : "Dashboard"}

              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
